import { useEffect, useState } from "react";
type BatchCourse = {
  academic_year?: string;
  acdmc_course_id?: string;
  class?: string;
  combination_code?: string;
  course_name?: string;
  emp_acdmc_crs_id?: string;
  emp_name?: string;
  employee_id?: string;
  gender?: string;
  level?: string;
  section?: string;
  semester?: string;
};
type user = {
  email_id?: string;
  employee_id?: string;
  name?: string;
  password?: string;
  profile_picture?: string | null;
};
const useUserData = () => {
  const [data, setData] = useState<any>({
    employee_id: localStorage.getItem("employee_id"),
    school_code: localStorage.getItem("school_code"),
    userData: {} as user,
    course: {} as BatchCourse,
    coruse_cohort: {} as any,
  });

  useEffect(() => {
    const employee_id = localStorage.getItem("employee_id") || "";
    const school_code = localStorage.getItem("school_code") || "";
    const userData = JSON.parse(localStorage.getItem("userData") || "{}");
    const encoded = localStorage.getItem("batch");
    const coruse_cohorts = JSON.parse(
      localStorage.getItem("coruse_cohorts") || "{}",
    );
    const batch = encoded ? JSON.parse(atob(encoded)) : null;
    // console.log(batch);
    setData({
      employee_id,
      school_code,
      course: batch || {},
      userData: userData || {},
      coruse_cohort: coruse_cohorts,
    });
  }, []);

  return data;
};

export default useUserData;
